import {
  useOptimizationState,
  useOptimizationWorkflow,
} from 'components/common-form/sidePanel/advisory/basket-optimizer/hooks';
import { FormattedMessage } from 'react-intl';

type Props = {
  tabId: string;
};
export function BasketOptimizerWorkflowToggle({ tabId }: Props) {
  const { isOptimizing, canOptimize } = useOptimizationState(tabId);
  const { onOptimizeCancelled, onOptimizeRequested } = useOptimizationWorkflow(tabId);
  return !isOptimizing ? (
    <button
      id="startOptimize"
      type="button"
      onClick={onOptimizeRequested}
      disabled={!canOptimize}
      data-id="start-button"
      data-e2e="basket-optimizer-start-optimization-btn"
      className="btn btn-discreet-info btn-lg w-100"
    >
      <FormattedMessage id="basketOptimizer.startOptimisation" />
    </button>
  ) : (
    <button
      type="button"
      onClick={onOptimizeCancelled}
      data-id="cancel-button"
      data-e2e="basket-optimizer-cancel-optimization-btn"
      className="btn btn-discreet-danger btn-lg w-100"
    >
      <FormattedMessage id="basketOptimizer.cancelOptimisation" />
    </button>
  );
}
